











import { Component, Model, Prop, Vue, Watch } from 'vue-property-decorator';

import {
	DxPopup,
	DxPosition,
	DxToolbarItem
} from 'devextreme-vue/popup';

@Component({
	components: {
		DxPopup,
		DxPosition,
		DxToolbarItem
	}
})
export default class Popup extends Vue {

	@Model('update:show-popup', { type: Boolean, default: false }) showPopup!: boolean | null;

	@Prop({ type: Boolean, default: true }) closeOnOutsideClick!: boolean;
	@Prop({ type: Boolean, default: false }) dragEnabled!: boolean;
	@Prop({ type: Boolean, default: true }) showCloseButton!: boolean;
	@Prop({ type: String, default: 'Set my title' }) title!: string;
	@Prop({ type: String, default: '' }) additionalCaption!: string;
	@Prop({ type: [Number, String], default: '50vh' }) height!: number | string;
	@Prop({ type: [Number, String], default: '40vw' }) width!: number | string;

	@Prop({ type: Object, default: () => ({}) }) dxPopupProps: any;

	internalShowPopup = false;

	get internalProps() {
		return {
			'position': 'center',
			...this.dxPopupProps,
			'close-on-outside-click': this.closeOnOutsideClick,
			'drag-enabled': this.dragEnabled,
			'show-close-button': this.showCloseButton,
			'height': this.height,
			'title': this.title,
			'visible': this.internalShowPopup,
			'width': this.width
		};
	}

	onUpdateVisible(value: boolean) {
		this.internalShowPopup = value;
		this.$emit('update:show-popup', value);
	}

	changeSelectBoxText(element: any, text: string) {
		if ((element[0].dataset.dx_placeholder.includes('Select...'))) {
			element[0].dataset.dx_placeholder = text;
		}
	}

	async mounted() {
		if (this.additionalCaption) {
			this.changeSelectBoxText(document.getElementsByClassName('dx-placeholder'), this.additionalCaption);
		}
	}

	@Watch('showPopup', { immediate: true })
	onShowPanelChange(value: boolean | null) {
		if (value == null)
			this.internalShowPopup = false;
		else
			this.internalShowPopup = value;
	}

}

